import { useState, useEffect, useCallback } from 'react';
import i18n from 'i18next';
import { generateFontFamily } from 'common/utils/generateFontFamily';

const useGetFontFamilyByI18nLang = ({ isClient, language, isGlobal = false }) => {
    const [newLang, setNewLang] = useState(i18n.language);
    const [fontFamily, setFontFamily] = useState('');

    const handleLanguageChanged = useCallback(lang => {
        setNewLang(lang);
    }, []);

    useEffect(() => {
        if (isClient && isGlobal) {
            i18n.on('languageChanged', handleLanguageChanged);
            return () => {
                i18n.off('languageChanged', handleLanguageChanged);
            };
        }
    }, [handleLanguageChanged, isClient, isGlobal]);

    useEffect(() => {
        if (isClient && newLang) {
            const newFontFamily = generateFontFamily(newLang);
            setFontFamily(newFontFamily);
        }
    }, [isClient, newLang]);

    if (!isClient) {
        return generateFontFamily(language || i18n.language);
    }

    return fontFamily;
};

export default useGetFontFamilyByI18nLang;
